import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=647960ed"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"
import style0 from "./AppointmentForm.vue?vue&type=style&index=0&id=647960ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports